import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import shape from "../../../assets/img/bg/attendance-bg-2.png";

export default function AttendanceStatus() {
  const [date, setDate] = useState(new Date());
  const [open, setOpen] = useState(false);

  return (
    <Card className="status-card h-100">
      <Card.Body>
        {/* HEADER */}
        <div className="status-header">
          <h6>Attendance Status</h6>

          {/* CLICKABLE ICON */}
          <div
            className="attendance-calendar-icon"
            onClick={() => setOpen(!open)}
          >
            <FiCalendar className="text-dark" size={16} />
          </div>
        </div>

        {/* CALENDAR */}
        {open && (
          <div className="calendar-popup">
            <DatePicker selected={date} onChange={(d) => setDate(d)} inline />
          </div>
        )}

        {/* SHAPE */}
        <img src={shape} alt="" className="bg-shape" />

        {/* TOTAL */}
        <p className="working-text">Total Working Days</p>
        <h2 className="working-days">300</h2>

        {/* PROGRESS */}
        <div className="progress-container">
          <div className="progress-inner">
            <div className="bar b1"></div>
            <div className="bar b2"></div>
            <div className="bar b3"></div>
            <div className="bar b4"></div>
            <div className="bar b5"></div>
          </div>
        </div>

        {/* LIST */}
        <div className="status-list">
          {[
            { name: "Present", value: "2458" },
            { name: "WFH", value: "187" },
            { name: "Late", value: "89" },
            { name: "On Leave", value: "78" },
            { name: "Absent", value: "124" },
          ].map((item, i) => (
            <div className="status-row" key={i}>
              <div className="labels">
                <span className="dot"></span>
                {item.name}
              </div>
              <span className="value">{item.value}</span>
            </div>
          ))}
        </div>
      </Card.Body>

      <style>
        {`
        .status-card {
          background: linear-gradient(135deg, #0b1220, #1c2433);
          border-radius: 5px;
          border: none;
          color: #fff;
          position: relative;
          overflow: visible;
          padding: 12px; /* reduced */
        }

        
        /* HEADER */
        .status-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .status-header h6 {
          font-size: 15px;
          font-weight: 600;
        }

        .attendance-calendar-icon {
          width: 34px;
          height: 34px;
          background: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index:100;
        color: dark;
        }

        /* CALENDAR POPUP */
        .calendar-popup {
          position: absolute;
          top: 50px;
          right: 10px;
          z-index: 999;
        }

        /* SHAPE */
        .bg-shape {
          position: absolute;
          right: -0px;
          top: -0px;
          width: 140px;
          opacity: 0.9;
        }

        /* TEXT */
        .working-text {
          color: #9ca3af;
          font-size: 12px;
          margin-top: 7px;
        }

        .working-days {
          font-size: 26px;
          font-weight: 700;
          margin-bottom: 7px;
        }

        /* PROGRESS */
        .progress-container {
          background: #2a3344;
          padding: 4px;
          border-radius: 20px;
          margin: 8px 0;
        }

        .progress-inner {
          display: flex;
          gap: 4px;
        }

        .bar {
          height: 24px; /* reduced */
          border-radius: 10px;
        }

        .b1 { width: 40%; background: #ff6a00; }
        .b2 { width: 20%; background: #fb923c; }
        .b3 { width: 15%; background: #f97316; }
        .b4 { width: 10%; background: #fdba74; }
        .b5 { width: 15%; background: #fca874; }

        /* LIST */
        .status-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 7px 0; /* reduced */
        }

        .labels {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255,255,255,0.06);
          padding: 5px 10px;
          border-radius: 20px;
          font-size: 13px;
        }

        .dot {
          width: 6px;
          height: 6px;
          background: #ff6a00;
          border-radius: 50%;
        }

        .value {
          font-weight: 600;
          font-size: 13px;
        }

        /* CALENDAR THEME (ORANGE) */
        .react-datepicker {
          border-radius: 10px;
          border: none;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }

        .react-datepicker__day--selected {
          background: #ff6a00 !important;
          color: white !important;
        }

        .react-datepicker__day:hover {
          background: #fed7aa;
        }

        /* MOBILE */
        @media (max-width: 1024px) {
          .status-card {
            margin-top: 20px;
          }

          .bg-shape {
            width: 100px;
          }
        }
        `}
      </style>
    </Card>
  );
}
